import axios from "axios"
import { URL_BASE } from '../../../config/config'

const RESOURCE = 'users'

export default {
    state: {
        items: {
            data: []
        },

        active_users: {
            data: []
        },

        store: false
    },

    mutations: {
        LOAD_USERS (state, data) {
            state.items = data
        },

        ACTIVE_USERS (state, data) {
            state.active_users = data
        },
        
        STORE_USER (state, status) {
            state.store = status
        }
    },

    actions: {
        loadUsers(context, params) {
            context.commit('PRELOADER', true);
            axios.get(`${URL_BASE}${RESOURCE}`, {params})
                .then( response =>
                        {
                            context.commit('LOAD_USERS', response.data)
                        }
                )
                //.catch( errors => console.log(errors))
                .catch((error) => {
                    if(error.response && error.response.status === 401) {
                        window.location.href = "login";
                    }

                })
                .finally(() => context.commit('PRELOADER', false))
        },


        async loadActiveUsers({ commit, state }, params) {
            // Verifica se os dados já foram carregados
            if (state.active_users && state.active_users.data && state.active_users.data.length > 0) {
                return; // Evita nova requisição se já houver dados
            }
            
            commit('PRELOADER', true);
            axios.get(`${URL_BASE}${RESOURCE}`, { params })
            .then(response => {
                commit('ACTIVE_USERS', response.data);
            })
            .catch(error => {
                if (error.response && error.response.status === 401) {
                    window.location.href = "login";
                }
            })
            .finally(() => {
                commit('PRELOADER', false);
            });
        },

        async loadPromisseUsers({ commit }, params) {
            commit('PRELOADER', true);
            try {
                const response = await axios.get(`${URL_BASE}${RESOURCE}`, { params });
                return response.data; // Retorna diretamente os dados
            } catch (error) {
                if (error.response?.status === 401) {
                    window.location.href = "/login";
                }
                throw error; // Propaga o erro para o chamador
            } finally {
                commit('PRELOADER', false);
            }
        },

        async storeUser({ commit }, params) {
            commit('PRELOADER', true);
            
            try {
                const response = await axios.post(`${URL_BASE}${RESOURCE}`, params);
                return response.data;
            } catch (error) {
                if (error.response?.status === 401) {
                    window.location.href = "login";
                } else {
                    // Propaga o erro para tratamento no componente
                    throw new Error('Falha ao salvar usuário', { cause: error });
                }
            } finally {
                commit('PRELOADER', false);
            }
        },

        async updateUser({ commit }, params) {
            commit('PRELOADER', true);
            
            try {
                const response = await axios.put(`${URL_BASE}${RESOURCE}/${params.id}`, params);
                return response.data;
            } catch (error) {
                if (error.response?.status === 401) {
                    window.location.href = "login";
                } else {
                    // Adiciona informações extras ao erro (opcional)
                    error.userMessage = "Falha ao atualizar usuário";
                    throw error;
                }
            } finally {
                commit('PRELOADER', false);
            }
        },

        async loadUser({ commit }, id) {
            commit('PRELOADER', true);
            
            try {
                const response = await axios.get(`${URL_BASE}${RESOURCE}/${id}`);
                return response.data;
            } catch (error) {
                if (error.response?.status === 401) {
                    window.location.href = "login";
                }
                throw error; // Propaga o erro para o chamador
            } finally {
                commit('PRELOADER', false);
            }
        },

        async destroyUser({ commit }, id){
            commit('PRELOADER', true);

            try {
                await axios.delete(`${URL_BASE}${RESOURCE}/${id}`)
            } catch (error) {
                if(error.response?.status === 401){
                    window.location.href = "login";
                }
                throw error;
            } finally {
                commit('PRELOADER', false);
            }
        },

        async sendRequestPassword({ commit }, params) {
            commit('PRELOADER', true);

            try {
                await axios.get(`${URL_BASE}sendrequestpassword?email=${params.email}`)
            } catch (error) {
                if(error.response?.status === 401){
                    window.location.href = "login";
                }
                throw error;
            } finally {
                commit('PRELOADER', false);
            }
        },

    },

    getters: {

    }

}